import { foldPaymentModel } from '@atlassian/mpac-api-client';
import { makePaidAppPricing, makePaidAppPricingItem, PAID_PRICING_TYPE } from '@atlassian/mpac-pricing-utils';
import { FLAT_RATE_PRICING_ITEM_TYPE, PER_UNIT_PRICING_ITEM_TYPE, PVV_PRICING_NOT_SUPPORTED_MSG } from '@atlassian/mpac-types';
import { Either, Option } from 'funfix-core';
import { List, Record } from 'immutable';
export const FREE_PRICING_TYPE = 'FREE';
export const makeFreeAppPricing = Record({
  type: FREE_PRICING_TYPE
});
export function foldAppPricing(appPricing) {
  return function foldAppPricingInner(free, paid) {
    switch (appPricing.type) {
      case FREE_PRICING_TYPE:
        return free(appPricing);
      case PAID_PRICING_TYPE:
        return paid(appPricing);
      default:
        // Flow compile-time validation that we've handled every pricing type
        // prettier-ignore
        appPricing;
        return undefined;
    }
  };
}
const parseUnitCount = unitCount => unitCount === -1 ? Number.POSITIVE_INFINITY : unitCount;
const makeFlatRatePricingItemFromMarketplaceAppFlatRatePricingItem = flatRateItem => makePaidAppPricingItem({
  amount: flatRateItem.amount,
  currencyCode: flatRateItem.currencyCode,
  unitCount: parseUnitCount(flatRateItem.unitCount),
  type: FLAT_RATE_PRICING_ITEM_TYPE
});
const resolveMonthlyItems = (flatRateItems, perUnitItems) => flatRateItems.filter(i => i.monthsValid === 1).map(makeFlatRatePricingItemFromMarketplaceAppFlatRatePricingItem).concat(perUnitItems.filter(i => i.monthsValid === 1).map(perUnitItem => makePaidAppPricingItem({
  amount: perUnitItem.amount,
  currencyCode: perUnitItem.currencyCode,
  unitCount: parseUnitCount(perUnitItem.unitCount),
  type: PER_UNIT_PRICING_ITEM_TYPE
})));
const resolveAnnualItems = flatRateItems => flatRateItems.filter(i => i.monthsValid === 12).map(makeFlatRatePricingItemFromMarketplaceAppFlatRatePricingItem);
export const makeAppPricingFromMarketplaceAppData = (paymentModel, marketplaceAppPricing) => Option.of(paymentModel).map(pm => foldPaymentModel(pm)(() => Either.right(makeFreeAppPricing()), () => {
  if (!marketplaceAppPricing) {
    return Either.left('marketplaceAppPricing must be supplied for paid apps');
  }
  return marketplaceAppPricing.fold(marketplaceAppPricingErrorResponse => Either.left("Error while resolving pricing for paid app: ".concat(marketplaceAppPricingErrorResponse)), marketplaceAppPricingRes => {
    const flatRateItems = List(marketplaceAppPricingRes.items);
    return Either.right(makePaidAppPricing({
      annual: resolveAnnualItems(flatRateItems),
      monthly: resolveMonthlyItems(flatRateItems, Option.of(marketplaceAppPricingRes.perUnitItems).map(List).getOrElse(List()))
    }));
  });
}, () => Either.left(PVV_PRICING_NOT_SUPPORTED_MSG))).getOrElse(Either.left('paymentModel or parent data items not present'));